import {useDisclosure} from '@sollapay/ui/hooks';
import {AccountMenu, AppSidebar as GenericAppSidebar, LanguageSwitcher} from '@sollapay/web-core';
import {useTranslation} from 'react-i18next';

import {config} from '@/app';
import {AccountSettingsModal} from '@/features/account-settings';
import {useCurrentUserIdentity} from '@/hooks';

import {AppLogo, AppLogomark} from './AppLogo';
import {guestNavGroups} from '../config/nav-items.config';
import {APP_SIDEBAR_STORAGE_KEY} from '../config/sidebar.config';

import type {FC, ReactNode} from 'react';

interface GuestSidebarProps {
  children: ReactNode;
}

export const GuestSidebar: FC<GuestSidebarProps> = ({children}) => {
  const {t} = useTranslation(['nav', 'guest']);
  const {userId, displayName, pictureUrl, profile} = useCurrentUserIdentity();
  const accountSettingsModal = useDisclosure();

  const navGroups = guestNavGroups.map(group => ({
    id: group.id,
    label: t(group.labelKey),
    items: group.items.map(item => ({...item, label: t(item.labelKey)}))
  }));

  return (
    <GenericAppSidebar
      logo={<AppLogo />}
      collapsedLogo={<AppLogomark />}
      footer={
        <>
          {config.features.enableLanguageSwitcher && <LanguageSwitcher />}
          <AccountMenu
            claimsNamespace={config.auth0.claimsNamespace}
            logoutReturnTo={window.location.origin}
            role={t('guest:role')}
            onOpenAccountSettings={accountSettingsModal.open}
            profile={{name: displayName, picture: pictureUrl}}
          />
          <AccountSettingsModal
            isOpen={accountSettingsModal.isOpen}
            profile={profile}
            avatarSeed={userId}
            onClose={accountSettingsModal.close}
          />
        </>
      }
      navGroups={navGroups}
      storageKey={APP_SIDEBAR_STORAGE_KEY}
    >
      {children}
    </GenericAppSidebar>
  );
};
